import { useMemo } from 'react';

export function useRole() {
  const role = useMemo(() => {
    if (typeof window === 'undefined') return false;

    // Get the current URL path
    const path = window.location.pathname;

    // Split the path into segments
    const segments = path.split('/').filter(Boolean); // Removes empty segments (e.g., from leading '/')

    // Return the first segment as the role
    return segments[0] || null; // Return null if no role found
  }, []);

  return role;
}
